import { NETWORK } from '@shared/utils/constant'
import { LocalStorage } from '@injectivelabs/utils/storage'

export const localStorage: LocalStorage = new LocalStorage(`tc-v2-${NETWORK}`)
